import { Tablet } from '@/styles/layout';
import { useRef } from 'react';
import styled from 'styled-components';

const BrandStorySection = () => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <BrandStory ref={ref} opacity={1}>
      <BrandStoryText>
        {'병원 문 닫았다는 이유로\n바빠서 어쩔 수 없다는 이유로\n더 이상 아픔을 참거나 미루지 마세요.'}
      </BrandStoryText>
      <BrandStoryText>
        {'아플 때, 닥터나우를 열면'}
        <BrandStoryHighlightText>병원이 우리를 찾아올 거예요.</BrandStoryHighlightText>
      </BrandStoryText>
    </BrandStory>
  );
};

export default BrandStorySection;

const BrandStory = styled.div<{ opacity: number }>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 100px 0 100px 0;
  gap: 53px;
  justify-content: center;
  ${({ theme }) => `
    background: ${theme.color.gray800};
  `};

  @media screen and (max-width: ${Tablet}) {
    gap: 32px;
  }

  
`;

const BrandStoryText = styled.div`
  white-space: pre-wrap;
  text-align: center;
  ${({ theme }) => `
     ${theme.typography.UI32B};
     color: ${theme.color.white}; 
    `};
  @media screen and (max-width: ${Tablet}) {
    ${({ theme }) => `
     ${theme.typography.UI18B};
    `}
  }
`;

const BrandStoryHighlightText = styled(BrandStoryText)`
  ${({ theme }) => `
    color: ${theme.color.primary500};
  `}
`;
